import { Directive } from '@angular/core';

@Directive({
  selector: '[appOverlayBottom]'
})
export class OverlayBottomDirective { }
